module.exports = __webpack_public_path__ + "img/2.51f7f638.webp";